import { FormattedMessage } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';
import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { messages } from './messages';

import styles from './select-plan-button.module.css';

/**
 * @param {object} props - Component props
 * @param {boolean} props.isCurrentPlan - Whether this is the current plan
 * @param {boolean} props.isDeselectAllowed
 * @param {boolean} props.isSelectedPlan - Whether this plan is selected
 * @param {boolean} props.isCurrentBillingPlanTrial - Whether this is the current billing plan trial
 * @param {() => void} props.onClick - Callback function when the button is clicked
 * @returns {React.JSX.Element | undefined} The rendered component
 */
export const SelectPlanButton = ({ isCurrentPlan, isDeselectAllowed, isSelectedPlan, onClick, isCurrentBillingPlanTrial }) => {
  const className = styles['select-plan-button'];

  if (isCurrentPlan) {
    return (
      <Button className={className} disabled theme={THEME_CONSTANTS.primary}>
        <FormattedMessage {...messages.current} />
      </Button>
    );
  }

  if (!isSelectedPlan) {
    return (
      <Button className={className} onClick={onClick} theme={THEME_CONSTANTS.secondary}>
        <FormattedMessage {...messages.select} />
      </Button>
    );
  }

  if (isDeselectAllowed) {
    return (
      <Button className={className} onClick={onClick} theme={THEME_CONSTANTS.ghost}>
        <FormattedMessage {...messages.deselect} />
      </Button>
    );
  }

  if (isCurrentBillingPlanTrial && isSelectedPlan) {
    return <Text className={styles['selected-label']} textType={TextType.Label} value={messages.selected} />;
  }
};
